import React from 'react';
import { useTopPanelFromStack } from '../../redux/panels/selectors';
import { PanelsThunk } from '../../redux/panels/thunks';
import { useAppDispatch } from '../../redux/store';
import { useTutorialShowsCharacterButtons } from '../../redux/tutorial/selectors';
import { CharacterButton } from '../CharacterButton/CharacterButton';
import { RollResultsNotification } from '../RollResultsNotification/RollResultsNotification';
import { TutorialEnemy } from '../TutorialEnemy/TutorialEnemy';

import styles from './TopToolbar.module.css';

type Props = {
  showAvatar: boolean;
};

export const TopToolbar: React.FC<Props> = ({ showAvatar }) => {
  const dispatch = useAppDispatch();
  const leftTopPanel = useTopPanelFromStack('left');
  const showCharacterButtons = useTutorialShowsCharacterButtons();

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        {showCharacterButtons ? (
          <div className={styles.hero}>
            <CharacterButton
              showAvatar={showAvatar}
              onClick={() => {
                if (!leftTopPanel) {
                  dispatch(PanelsThunk.pushPanel('left', 'hero'));
                }
              }}
            />
          </div>
        ) : (
          <div className={styles.heroPlaceholder} />
        )}

        <div className={styles.enemy}>
          <TutorialEnemy />
        </div>
      </div>

      <RollResultsNotification className={styles.notification} />
    </div>
  );
};
